import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { EmojiProvider } from 'react-apple-emojis'

import useRetailerApi from '@/useRetailerApi'
import { LanguageProvider } from '@/contexts/LanguageContext'
import { CartProvider } from '@/contexts/CartContext'

import Layout from '@/components/Layout'
import LoadingScreen from '@/components/LoadingScreen'
import LoginForm from '@/components/LoginForm'
import Dashboard from '@/pages/Dashboard'
import NotFound from '@/pages/NotFound'
import WarrantyAssociation from '@/pages/WarrantyAssociation'
import Cart from '@/pages/Cart'
import Orders from '@/pages/Orders'

import emojiData from 'react-apple-emojis/src/data.json'

function App() {
    const urlParams = new URLSearchParams(window.location.search)
    const defaultPublicId =
        urlParams.get('id') || localStorage.getItem('retailer_public_id') || ''
    const { retailer, isLoading, isLoggingIn, login, logout } = useRetailerApi()
    const isAdmin = retailer?.access_level === 'admin'

    return (
        <EmojiProvider data={emojiData}>
            <LanguageProvider>
                {isLoading && !isLoggingIn ? (
                    <LoadingScreen />
                ) : !retailer ? (
                    <LoginForm
                        onLogin={login}
                        isLoggingIn={isLoggingIn}
                        defaultPublicId={defaultPublicId}
                    />
                ) : (
                    <CartProvider collections={retailer.collections}>
                        <BrowserRouter>
                            <Routes>
                                <Route element={<Layout onLogout={logout} retailer={retailer} />}>
                                    <Route path="/" element={<Dashboard />} />
                                    <Route
                                        path="/warranty"
                                        element={<WarrantyAssociation />}
                                    />
                                    {isAdmin && (
                                        <>
                                            <Route path="/orders" element={<Orders />} />
                                            <Route path="/cart" element={<Cart />} />
                                        </>
                                    )}
                                    <Route path="*" element={<NotFound />} />
                                </Route>
                            </Routes>
                        </BrowserRouter>
                    </CartProvider>
                )}
            </LanguageProvider>
        </EmojiProvider>
    )
}

export default App
